/// <reference types="./getEntities.d.ts" />
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { ok } from '@dossierhq/core';
import { createSqliteSqlQuery, } from '@dossierhq/database-adapter';
import { queryMany } from '../QueryFunctions.js';
import { assertIsDefined } from '../utils/AssertUtils.js';
import { resolveEntityFields, resolvePublishedEntityInfo } from '../utils/CodecUtils.js';
export async function publishedEntityGetEntities(database, context, references) {
    const { addValueList, query, sql } = createSqliteSqlQuery();
    sql `SELECT e.uuid, e.type, e.published_name, e.auth_key, e.resolved_auth_key, e.created_at, e.invalid, ev.schema_version, ev.encode_version, ev.fields`;
    sql `FROM entities e, entity_versions ev WHERE e.uuid IN ${addValueList(references.map((it) => it.id))}`;
    sql `AND e.published_entity_versions_id = ev.id`;
    const result = await queryMany(database, context, query);
    if (result.isError())
        return result;
    return ok(result.value.map((row) => {
        assertIsDefined(row.uuid);
        return {
            ...resolvePublishedEntityInfo(row),
            ...resolveEntityFields(row),
            id: row.uuid,
            resolvedAuthKey: row.resolved_auth_key,
        };
    }));
}
//# sourceMappingURL=getEntities.js.map